import { Auth } from 'aws-amplify';
import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Icon, Menu } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import { observer } from 'mobx-react-lite';
import PartnerStateContainer from '../UserInitializer/PartnerStateContainer';
import PartnerLogoComponent from '../../Pages/Admin/PartnerLogoComponent';

const NavigationMenu: React.FunctionComponent = () => {
  const location = useLocation();
  const history = useHistory();
  const { partnerStore, caregiverStore } = useAgeReadyContext();

  const logout = async () => {
    await Auth.signOut();
    caregiverStore.logout();
    history.push('/');
  };

  const getPartnerCustomStyling = () => {
    if (partnerStore.partnersByIdMap.has(caregiverStore.partnerCode || '')) {
      return {
        backgroundColor: partnerStore.partnersByIdMap.get(
          caregiverStore.partnerCode || ''
        )?.navigationBarColor,
        fontColor: partnerStore.partnersByIdMap.get(
          caregiverStore.partnerCode || ''
        )?.fontColor,
        marginBottom: 0,
      };
    } else {
      return {
        backgroundColor: '#ffffff',
        marginBottom: 0,
      };
    }
  };

  return (
    <div>
      <PartnerStateContainer>
        <Menu pointing secondary style={getPartnerCustomStyling()}>
          <PartnerLogoComponent />

          {!!caregiverStore.partnerCode && !!caregiverStore.isAdmin &&
            !location.pathname.includes('admin') && (
              <Menu.Item
                as={Link}
                active={
                  location.pathname === `admin/${caregiverStore.partnerCode}`
                }
                to={`admin/${caregiverStore.partnerCode}`}
                style={getPartnerCustomStyling()}
              >
                Admin
              </Menu.Item>
            )}
          <Menu.Item
            as={Link}
            active={location.pathname === '/home'}
            to='/home'
          >
            <Icon name='server' />
            Home
          </Menu.Item>
          <Menu.Item
            as={Link}
            active={location.pathname === '/user-profile'}
            to='/user-profile'
          >
            <Icon name='user outline' />
            User Profile
          </Menu.Item>
          <Menu.Item onClick={logout} to='/'>
            <Icon name='sign-out' />
            Sign Out
          </Menu.Item>
        </Menu>
      </PartnerStateContainer>
    </div>
  );
};

export default observer(NavigationMenu);
